import axios from 'axios/index'

const namespaced = true

const state = {
  display: null
}
const getters = {}
const actions = {
  getShippingDisplay () {
    return axios({
      method: 'GET',
      url: '/api/private/v1.0/ships/'
    })
      .then(response => {
        return response.data
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {}
export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
